/* eslint-disable no-case-declarations */
import * as visitSummaryTypes from '../types/visitSummaryTypes';
import initialState from './initialState';
import { updateObject } from 'utils';

const visitSummary = (state = initialState.visitSummary, { type, payload }) => {
  switch (type) {
    case visitSummaryTypes.FETCH_VISIT_SUMMARY_START:
      return updateObject(state, { isLoading: true });

    case visitSummaryTypes.FETCH_VISIT_SUMMARY_SUCCESS:
      return updateObject(state, { isLoading: false, items: payload });

    case visitSummaryTypes.FETCH_VISIT_SUMMARY_FAIL:
      return updateObject(state, { isLoading: false });


    default:
      return { ...state };
  }
};

export default visitSummary;
